import { Typography } from '@global-engineering-shared/gweb-material-ui';

import ChipListDetail from 'features/EntityDetails/components/EntityDetails/ChipListDetail';
import { BroadsignFrame } from 'types/detailsEntityType';

type BroadsignFramesRowProps = {
  broadsignFrames: BroadsignFrame[] | null;
  previousBroadsignFrames?: BroadsignFrame[] | null;
};

const BroadsignFramesRow = ({
  broadsignFrames,
  previousBroadsignFrames,
}: BroadsignFramesRowProps) => {
  const hasBroadsignFrames =
    (broadsignFrames?.length ?? 0) > 0 || (previousBroadsignFrames?.length ?? 0) > 0;

  if (!hasBroadsignFrames) {
    return (
      <Typography variant="body2" fontWeight={400}>
        No Broadsign Frames
      </Typography>
    );
  }

  return (
    <ChipListDetail
      headerText="Broadsign Frames"
      items={broadsignFrames ?? []}
      previousItems={previousBroadsignFrames}
      getKey={(broadsignFrame: BroadsignFrame): string =>
        broadsignFrame.broadsignFrameId || 'Unknown Broadsign Frame ID'
      }
      getLabel={(broadsignFrame: BroadsignFrame): string =>
        `${broadsignFrame.broadsignFrameId} | ${broadsignFrame.displayUnitId}`
      }
      getTooltip={(broadsignFrame: BroadsignFrame): string[] => [
        `Broadsign Frame ID: ${broadsignFrame.broadsignFrameId}`,
        `Display Unit ID: ${broadsignFrame.displayUnitId}`,
      ]}
    />
  );
};

export default BroadsignFramesRow;
